const COMMENTS = [
  {
    name: '追剧小达人',
    time: '2小时前',
    content: '番茄影视真的太良心了！狂飙全集高清不卡顿，画质比我之前用的几个站都好太多了，已经安利给全家人了。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20minimalist%20avatar%20illustration%20of%20a%20young%20Chinese%20girl%20with%20warm%20smile%2C%20flat%20design%2C%20soft%20peach%20background%2C%20simple%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    tag: '忠实用户',
  },
  {
    name: '电影爱好者阿杰',
    time: '5小时前',
    content: '片库真的太全了，冷门老片都能找到，而且没有烦人的弹窗广告。高清播放体验秒杀同类站点，持续关注中。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20illustration%20of%20a%20Chinese%20man%20with%20glasses%2C%20friendly%20expression%2C%20flat%20design%2C%20soft%20blue%20background%2C%20simple%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    tag: '影评达人',
  },
  {
    name: '周末宅家党',
    time: '1天前',
    content: '不用注册就能看真的爽！周末一口气刷完了鬼灭之刃锻刀村篇，画质清晰流畅，用平板看体验超级棒。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20illustration%20of%20a%20young%20Chinese%20person%20with%20headphones%2C%20cool%20casual%20style%2C%20flat%20design%2C%20soft%20green%20background%2C%20simple%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    tag: '动漫迷',
  },
  {
    name: '老影迷老王',
    time: '2天前',
    content: '从建站初期就在用了，看着片库越来越丰富，功能越来越完善。三体和流浪地球2的画质真的是电影级的，强烈推荐。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20avatar%20illustration%20of%20a%20middle-aged%20Chinese%20man%20smiling%20warmly%2C%20flat%20design%2C%20soft%20warm%20gray%20background%2C%20simple%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    tag: '资深用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">用户口碑</h2>
          <p className="text-sm text-foreground-500 mt-2">听听影迷们怎么说番茄影视</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto">
          {COMMENTS.map((comment) => (
            <div key={comment.name} className="bg-background-50 rounded-2xl p-5 md:p-6">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-11 h-11 rounded-full bg-background-200 overflow-hidden shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-semibold text-foreground-950">{comment.name}</h3>
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100/80 text-accent-700 font-medium">
                      {comment.tag}
                    </span>
                  </div>
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-amber-400 text-xs" />
                    ))}
                    <span className="text-xs text-foreground-400 ml-2">{comment.time}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}